import { Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCommunitySettings } from '@guuru/community-web';
import { usePageTitle } from '@guuru/react-hooks';
import HomeExperts from '../../components/Experts/HomeExperts';
import Feedback from '../../components/Feedback';
import Stats from '../../components/Stats';

const { Title } = Typography;

const Home = function () {
  const { partnerName } = useCommunitySettings();
  usePageTitle(
    `${partnerName} Community Advice & Trusted Members | GUURU`,
    `Explore the ${partnerName} community. Discover experienced members sharing real product knowledge.`,
  );
  const { t } = useTranslation();
  return (
    <>
      <Title
        level={1}
        style={{ marginBottom: 0, paddingTop: 24, textAlign: 'center' }}
      >
        {t('chat:::communityHeadline')}
      </Title>
      <Stats />
      <HomeExperts />
      <Feedback />
    </>
  );
};

export default Home;
